<template>
  <div>

    <button v-if="isMobile"
            @click="save"
            ref="save"
            class="tabs-menu__item tabs-menu__item--save"
            :class="{loading: loading, 'opacity-50': !snapshots.length, 'cursor-not-allowed': !snapshots.length }">
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
    </button>

    <button v-else
            @click="save"
            ref="save"
            :class="{loading: loading, 'opacity-50': !snapshots.length, 'cursor-not-allowed': !snapshots.length }"
            class="button button__red sidebar__configuration-save">
      save
    </button>


  </div>
</template>

<script>
  import { isMobile } from 'mobile-device-detect';
  import { mapGetters } from 'vuex';

  export default {
    name: "SaveButton",
    data() {
      return {
        isMobile: isMobile,
        titleEditable: '',
        loading: false,
      }
    },
    computed: {
      ...mapGetters('snapshots',[
        'snapshots',
      ]),
    },
    methods: {
      saveCallback(success = true) {

        if(success)
          this.$Progress.finish();
        else
          this.$Progress.fail();

        this.loading = false;
      },
      save() {

        if(window.suite_editor_3d_save && this.snapshots.length > 0) {

          try {
            this.$Progress.start();
            this.loading = true;
            let snapshots = JSON.stringify(this.snapshots); //JSON.parse( JSON.stringify(this.snapshots) ) Riccardo mi ha chieso di togliere il JSON.parse perchè gli da qualche problema sul backend

            window.suite_editor_3d_save(snapshots,this.saveCallback);

          } catch (e) {
            console.error(`An error occurred on save: ${e}`);
            this.saveCallback(false);
          }

        }

      }
    }
  }
</script>

<style scoped>
  .sidebar__configuration-save {
    text-transform: uppercase;
    min-width: 160px;
    text-align: center;
    /*margin-bottom: 20px;*/
  }

  .sidebar__configuration-save:hover, .sidebar__configuration-save.loading {
    opacity: 0.4;
  }

  .tabs-menu__item.tabs-menu__item--save {
    color: white;
    background-color: red;
    border: 1px solid red;
    padding: 0px;
    /*font-size: 14px;*/
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

</style>